import axios from "axios";
import  store  from "../store"; // Redux store
import React, { useState } from 'react';
import { logout, updateToken } from "../redux/slices/authSlice"; // Redux actions
import SessionExpiredModal from "../components/SessionExpiredModal";
import { useNavigate } from 'react-router-dom'; // Import useNavigate


//create a wrapper component to manage thge model
const AxiosInterceptor = ({ children }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  //const navigate = useNavigate(); // Initialize the navigate function

  // Show the modal
  const showModal = () => {
    setIsModalVisible(true);
  };

  // Handle modal confirmation (redirect to login)
  const handleOk = () => {
    setIsModalVisible(false);
    //logout();
    store.dispatch(logout()); // Logout if refresh fails
    //navigate('/login'); // Use navigate to redirect to the login page
    window.location.href = '/login'; // Redirect to login page
  };
// Set the base URL for all requests
//axios.defaults.baseURL = 'https://your-api-url.com';

// Request interceptor to attach the token - but for now we don't need this 
/*axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );*/

  // Response interceptor to handle token expiration
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      //console.log("axios error :", error)
      console.log("Axios Responce Intercepter get called outer if ");
      // Check if the error is due to an expired token (e.g., status code 401)
      //if (error.response.status === 401 && !originalRequest._retry) {
      if(originalRequest._retry === undefined)
      {
        originalRequest._retry = false;
      }
      const errorName = error?.response?.data?.error?.name;
      const status = error?.response?.status;

      if ((errorName === "TokenExpiredError" || status === 401) && !originalRequest._retry) {
      //if (error.response.data.error.name === "TokenExpiredError" && !originalRequest._retry) {
        originalRequest._retry = true; // Mark the request as retried
  
        try {
          // Attempt to refresh the token
          //const newToken = await refreshToken();
  
          // Update the token in local storage
          //localStorage.setItem('jwtToken', newToken);
          //store.dispatch(updateToken(newToken));
  
          // Retry the original request with the new token
          //originalRequest.headers.Authorization = `Bearer ${newToken}`;
          //return axios(originalRequest);
          console.log("Axios Responce Intercepter get called");
          showModal();
        } catch (refreshError) {
          // If token refresh fails, log out the user
          store.dispatch(logout()); // Logout if refresh fails
          return Promise.reject(refreshError);
        }
      }
  
      // If the error is not due to an expired token, reject the promise
      //return Promise.reject(error.response.data);
      return Promise.reject(error);
    }
  );

// axios.interceptors.response.use(function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   }, function (error) {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     return Promise.reject(error);
//   });

  const refreshToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken'); // Assuming you store a refresh token
      const response = await axios.post('/refresh-token', {
        refreshToken,
      });
      return response.data.token; // Assuming the new token is returned in the response
    } catch (error) {
      throw new Error('Failed to refresh token');
    }
  };

  // Function to log out the user
/*const logout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiration');
    window.location.href = '/login'; // Redirect to login page
  };*/
  return (
    <>
      {children}
      <SessionExpiredModal visible={isModalVisible} onOk={handleOk} />
    </>
  );
};
  export default AxiosInterceptor;